import client from './client';
import { BlogPost, BlogPostPayload, BlogPostSummary } from '../types/blog';

/** Every post, drafts included, newest first. Bodies are NOT included. */
export async function getPosts(): Promise<BlogPostSummary[]> {
  const res = await client.get('/api/admin/blog');
  return Array.isArray(res.data?.posts) ? res.data.posts : [];
}

/** One post in full — the only read that returns `body`, for the edit form. */
export async function getPost(id: string): Promise<BlogPost> {
  const res = await client.get(`/api/admin/blog/${id}`);
  return res.data?.post;
}

export async function createPost(payload: BlogPostPayload): Promise<BlogPost> {
  const res = await client.post('/api/admin/blog', payload);
  return res.data?.post;
}

export async function updatePost(id: string, payload: BlogPostPayload): Promise<BlogPost> {
  const res = await client.put(`/api/admin/blog/${id}`, payload);
  return res.data?.post;
}

export async function deletePost(id: string): Promise<void> {
  await client.delete(`/api/admin/blog/${id}`);
}

/**
 * Is this slug free?
 *
 * Answered by reading the post list and comparing locally rather than by a
 * dedicated endpoint: there are tens of posts, not thousands, and the list is
 * already the cheapest admin read there is. `exceptId` is what lets a post keep
 * its own slug — without it every edit would report its own URL as taken.
 *
 * Advisory only. The server checks the same thing under a UNIQUE constraint and
 * answers 409, which is what actually prevents a collision; this exists so the
 * author finds out while typing rather than on save.
 */
export async function isSlugAvailable(slug: string, exceptId?: string): Promise<boolean> {
  const posts = await getPosts();
  return !posts.some((p) => p.slug === slug && p.id !== exceptId);
}
